import { gql } from '@apollo/client'
import countrySettings from './countrySettings.fragment'

export const HAS_COUNTRY_NATIONAL_CONTRACT_REFERENCE_LEVEL = gql`
  query HasCountryNationalContractReferenceLevel($country: Country!) {
    hasCountryNationalContractReferenceLevel(country: $country)
  }
`

export const GET_COUNTRY_SETTINGS = gql`
  query GetCountrySettings($country: Country!) {
    getCountrySettings(country: $country) {
      ...CountrySettings
    }
  }
  ${countrySettings}
`

export const GET_COUNTRIES_WHERE_REPORT_GENERATION_IS_ENABLED = gql`
  query GetCountriesWhereReportGenerationIsEnabled($reportType: ReportType!) {
    getCountriesWhereReportGenerationIsActive(reportType: $reportType)
  }
`

export const GET_COUNTRIES_AND_REPORT_GENERATION_FLAGS = gql`
  query GetCountriesAndReportGenerationFlags {
    getCountriesAndReportGenerationFlags {
      country
      createBigReport
      createSmallReport
      createPyramidReport
      createTargetReport
    }
  }
`

export const ARE_AGE_AND_CAREERPATH_VISIBLE = gql`
  query AreAgeAndCareerPathVisible($country: Country!) {
    isAgePyramidVisible(country: $country)
    isCareerPathEnabled(country: $country)
  }
`

export const GET_COUNTRY_LIST = gql`
  query GetCountriesList {
    getCountriesList
  }
`

export const GET_COUNTRIES_WITH_AGE_PYRAMID_VISIBLE_FLAG = gql`
  query GetCountriesWithAgePyramidVisibleFlag {
    getCountriesWithAgePyramidVisibleFlag {
      country
      isAgePyramidVisible
    }
  }
`

export const GET_COUNTRIES_WITH_BRANCH_OFFICE_VISIBLE_FLAG = gql`
  query GetCountriesWithBranchOfficeVisibleFlag {
    getCountriesWithBranchOfficeVisibleFlag {
      country
      isBranchOfficeVisible
    }
  }
`
